import React, { useEffect, useState } from "react";
import JSZip from "jszip";

import {
  getAbsenteeismContent,
  getCashAdvanceContent,
  getEmployeeContent,
} from "./PdfGenerate";
import { useLocation, useSearchParams } from "react-router-dom";
import { axios } from "../../../../../Global";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import generatePdf from "./pdfWorker.js"; // Import the generatePdf function

export default function DownloadLoader() {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const groupSelectedCandidateIds = JSON.parse(searchParams.get("candidates"));
  const arrivalId = searchParams.get("arrivalId");
  const [downloadingZip, setDownloadingZip] = useState(false);
  const [candidates, setCandidates] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    axios
      .get(`/dashboard/arrival-notification`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((result) => {
        const data = result?.data?.data?.arrival_notification;
        const currentArrivalNotification = data.find(
          (arrivalData) => arrivalData.id == arrivalId
        );
        if (currentArrivalNotification) {
          const currentCandidates = currentArrivalNotification?.candidate;
          const currentSelectedCandidates = currentCandidates?.filter(
            (candidate) => groupSelectedCandidateIds.includes(candidate.id)
          );
          setCandidates(currentSelectedCandidates);
        }
        setDataLoading(false);
      })
      .catch((error) => {
        dispatch(setAppError({ msg: error.message }));
        setDataLoading(true);
      });
  }, []);

  useEffect(() => {
    if (downloadingZip) {
      document.body.style.cursor = "progress"; // Change cursor to progress while downloading
    } else {
      document.body.style.cursor = "default";
    }
  }, [downloadingZip]);
  useEffect(() => {
    if (!dataLoading) {
      const generateAndDownloadPDF = async (content, filename) => {
        try {
          const { pdfBlob } = await generatePdf(content, filename); // Assuming you've exported generatePdf from pdfWorker.js
          return pdfBlob;
        } catch (error) {
          console.error("Error generating PDF:", error);
          // Handle error if needed
        }
      };

      const generateAllAgreements = async () => {
        const batchSize = 10; // Adjust batch size as needed
        const totalCandidates = candidates?.length;

        const zip = new JSZip();
        let batchIndex = 0;

        const processBatch = async () => {
          for (
            let i = batchIndex * batchSize;
            i < Math.min((batchIndex + 1) * batchSize, totalCandidates);
            i++
          ) {
            const person = candidates[i];

            const absenteeismContent = getAbsenteeismContent(person);
            const absenteeismBlob = await generateAndDownloadPDF(
              absenteeismContent,
              `${person.name}_Absenteeism_${i + 1}.pdf`
            );
            zip.file(
              `${person.name}_Absenteeism_${i + 1}.pdf`,
              absenteeismBlob,
              {
                binary: true,
              }
            );

            const cashAdvanceContent = getCashAdvanceContent(person);
            const cashAdvanceBlob = await generateAndDownloadPDF(
              cashAdvanceContent,
              `${person.name}_Cash_Advance_${i + 1}.pdf`
            );
            zip.file(
              `${person.name}_Cash_Advance_${i + 1}.pdf`,
              cashAdvanceBlob,
              {
                binary: true,
              }
            );

            const employeeContent = getEmployeeContent(person);
            const employeeBlob = await generateAndDownloadPDF(
              employeeContent,
              `${person.name}_Employee_Agreement_Contract_${i + 1}.pdf`
            );
            zip.file(
              `${person.name}_Employee_Agreement_Contract_${i + 1}.pdf`,
              employeeBlob,
              { binary: true }
            );
            // Calculate and update progress
            const newProgress = Math.floor(((i + 1) / totalCandidates) * 100);
            setProgress(newProgress);
          }

          batchIndex++;

          if (batchIndex < Math.ceil(totalCandidates / batchSize)) {
            setTimeout(processBatch, 100); // Introduce a delay between batches if needed
          } else {
            // All candidates processed, generate and download the zip
            zip
              .generateAsync({ type: "blob", streamFiles: true })
              .then((content) => {
                const zipBlob = new Blob([content], {
                  type: "application/zip",
                });
                const url = URL.createObjectURL(zipBlob);
                const link = document.createElement("a");
                link.href = url;
                link.download = "agreements.zip";
                link.click();
                setDownloadingZip(false);
                setProgress(0); // Reset progress after completion
                setTimeout(() => {
                  window.close();

                  const element = parent.document.getElementById(
                    "downloading-progress"
                  );
                  console.log(element);
                  if (element) {
                    element.remove();
                  }
                }, 1000);
              });
          }
        };

        setDownloadingZip(true);
        processBatch();
      };

      generateAllAgreements()
        .then((out) => console.log(out))
        .catch((err) => console.log(err));
    }
  }, [dataLoading]);
  return (
    <div className="relative  bg-blue min-h-screen flex flex-col gap-3 justify-center items-center">
      <p className="uppercase text-white absolute top-1 text-xs">
        Downloading your files
      </p>
      <div className="flex gap-3 items-center justify-between p-5 w-full">
        <div>
          <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-black bg-teal-200">
            In Progress
          </span>
        </div>
        <div className="text-right">
          <span className="text-xs font-semibold inline-block text-white">
            {`${progress}%`}
          </span>
        </div>
      </div>

      <div className="overflow-hidden h-2 text-xs flex rounded bg-teal-900 w-full fixed bottom-0">
        <div
          style={{ width: `${progress}%` }}
          className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-teal-200"
        ></div>
      </div>
    </div>
  );
}
